var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#f37320;stroke-linecap:round;stroke-miterlimit:10;}.c{fill:#f37320;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.462)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(0 0.038)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 17,
    height: 17,
    transform: "translate(0 0.038)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.316 4.265)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.241,18.606v-.5a1.62,1.62,0,0,1,.366-1.1l.819-1.124A2.055,2.055,0,0,0,22,14.6a1.1,1.1,0,0,0-1.185-1.136,1.251,1.251,0,0,0-1.27,1.161.107.107,0,0,1-.135.1l-.77-.135a.108.108,0,0,1-.1-.135,2.188,2.188,0,0,1,2.3-1.943,2.052,2.052,0,0,1,2.211,2.077,2.544,2.544,0,0,1-.623,1.589L21.609,17.3a1.26,1.26,0,0,0-.318.916V18.6a.115.115,0,0,1-.122.122h-.806A.114.114,0,0,1,20.241,18.606Zm-.061,1.173a.115.115,0,0,1,.122-.122h.929a.115.115,0,0,1,.122.122V20.83a.115.115,0,0,1-.122.122H20.3a.115.115,0,0,1-.122-.122Z",
    transform: "translate(-18.539 -12.508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.5d4229ee0c19ffa164590ff5e4509c7f.svg";
export { ForwardRef as ReactComponent };